import { render } from "./ProfileCreateUpdateForm.vue?vue&type=template&id=09c6bd68&scoped=true"
import script from "./ProfileCreateUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProfileCreateUpdateForm.vue?vue&type=script&lang=js"

import "./ProfileCreateUpdateForm.vue?vue&type=style&index=0&id=09c6bd68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c6bd68"]])

export default __exports__